import { createStore, combineReducers, applyMiddleware, compose } from 'redux';
import thunk from 'redux-thunk';
import webmaster from '../reducers/webmaster';
import offers from '../reducers/offers';
import app from '../reducers/app';
import intl from '../reducers/intl';
import modals from '../reducers/modals';
import manager from '../reducers/manager';
import { setGeoToOffers } from './enhancers/setGeoToOffers';
import setCookieLang from './enhancers/setCookieLang';

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

export default () => {
  const store = createStore(
    combineReducers({
      webmaster,
      offers,
      app,
      intl,
      manager,
      modals
    }),
    composeEnhancers(applyMiddleware(
      thunk,
      setGeoToOffers,
      setCookieLang
    )),
  );

  return store;
};
